import { HEARTBEAT_START, HEARTBEAT_STOP, HEARTBEAT_SUCCESS, HEARTBEAT_FAILURE } from "./actions";

const initialState = {
    active: false,
    heartbeatResult: {
        success: true,
    },
};

export default (state = initialState, action) => {
    switch (action.type) {
        case HEARTBEAT_START:
            return { ...state, active: true };
        case HEARTBEAT_STOP:
            return { ...state, active: false };
        case HEARTBEAT_SUCCESS:
            return { ...state, heartbeatResult: { success: true } };
        case HEARTBEAT_FAILURE:
            return { ...state, heartbeatResult: { success: false, ...action.payload } };
        default:
            return state;
    }
};
